/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputDate} from '../../../../../components/UI/Input'
import {Select} from '../../../../../components/UI/Select'
import {KTableProvider, useKTable} from '../../../../../contexts/KTableProvider'
import {SelectOption} from '../../../../../models/utility.model'
import {getSnackBar, getSnackBarToast} from '../../../../../util/snackBar'
import {ratioSalesSummarySchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {RatioSalesSummaryColumn, RatioSalesSummaryDto} from '../../../models/reports.model'
import {
  getRatioSalesSummaryCSVService,
  getRatioSalesSummaryExcelService,
  getRatioSalesSummaryPDFService,
  getRatioSalesSummaryService,
} from '../../../services/ratio.service'

const TableSalesSummary: FC = () => {
  const {setPagination, pagination, setData, data, loading, setLoading} = useKTable()
  const methods = useForm<RatioSalesSummaryDto>({
    resolver: yupResolver(ratioSalesSummarySchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [compani, setCompany] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [site, setSite] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [, setSubmited] = useState<boolean>(false)
  const {getCompanies, getClients, getSites} = useCentralServices()
  // const [datos, setDatos] = useState<RatioSalesSummaryColumn[]>([])
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(allData)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const response = await getRatioSalesSummaryExcelService({
        ...obj,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Resumen de Ventas-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const response = await getRatioSalesSummaryCSVService({
        ...obj,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Resumen de Ventas-${moment().format('DD/MM/YY HH:mm').toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const response = await getRatioSalesSummaryPDFService({
        ...obj,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Resumen de Ventas-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  const getRatios = async () => {
    try {
      // if (!submited) return
      setLoading(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const {data: response} = await getRatioSalesSummaryService({
        ...obj,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        let totalItem: RatioSalesSummaryColumn = {
          CampamentoNombre: 'TOTAL',
          CostoFijo: response.TotalCostoFijo,
          CostoVariable: response.TotalCostoVariable,
          CostoTotal: response.TotalCostoTotal,
        }
        let arrCompany = response.data.length > 0 ? [...response.data, totalItem] : response.data
        setData(arrCompany)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setSubmited(false)
      setLoading(false)
    }
  }

  useEffect(() => {
    getRatios()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const onSubmit = () => {
    setSubmited(true)
    getRatios()
    setSubmited(false)
  }

  const handleChangeDateIni = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaIni', value)
    setError('FechaIni', {})
  }

  const handleChangeDateFin = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaFin', value)
    setError('FechaFin', {})
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setClient([])
    setSite([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setSite([])
  }

  const handleClear = () => {
    reset()
    setClient([{value: '', label: 'TODOS'}])
    setSite([{value: '', label: 'TODOS'}])
    setData([])
    setPagination({...pagination, totalResults: 0})
  }

  const columns: Column<RatioSalesSummaryColumn>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
      accessor: 'CampamentoNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Costo Variable' />,
      accessor: 'CostoFijo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Costo Fijo' />,
      accessor: 'CostoVariable',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Costo Total' />,
      accessor: 'CostoTotal',
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Compañía:</label>
                  <Select
                    control={control}
                    name='CompaniaId'
                    data={compani}
                    errors={errors}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Site:</label>
                  <Select control={control} name='SiteId' data={site} errors={errors} />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Inicial:</label>
                  <InputDate
                    name='FechaIni'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDateIni}
                    // maxValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Final:</label>
                  <InputDate
                    name='FechaFin'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDateFin}
                    // maxValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={data.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={data.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={data.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const RatioSalesSummary = () => {
  return (
    <KTableProvider>
      <div>
        <TableSalesSummary />
        <SnackbarProvider />
      </div>
    </KTableProvider>
  )
}

export {RatioSalesSummary}
